import {connect} from 'react-redux';
import {Field, reduxForm} from 'redux-form/immutable';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import Form from '../../../../../ui/Form';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Alert from "../../../../../ui/Alert";
import styles from "../additions/css/Form.scss";
import Button from "../../../../../ui/Button";
import {renderField} from "./fields";

@injectIntl
class AdditionsForm extends Component {
    /* eslint-enable */
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        additions: ImmutablePropTypes.list.isRequired,
        onSubmit: PropTypes.func,
        handleSubmit: PropTypes.func,
        intl: intlShape,
        submitting: PropTypes.bool,
    }

    componentWillMount() {
        window.scrollTo(0, 0);
    }

    renderItem(item, key) {
        const {validationData} = this.props;
        const submitErrors = validationData.getIn(['additions', 'submitErrors']);

        const params = item.get('params');

        switch (item.get('type')) {

            case 'note':
                return <div>Note</div>

            case 'confirmation':
                return <Form.Row key={key} className={styles.confirmation}>
                    <Field
                        component={renderField}
                        hint={params.get('hint', null)}
                        label={params.get('label', null)}
                        name={item.get('name')}
                        type="checkbox"
                        error={submitErrors && submitErrors.getIn(['additions', item.get('name')])}
                    />
                </Form.Row>

            case 'input':
                return (
                    <Form.Row key={key}>
                        <Field
                            component={renderField}
                            hint={params.get('hint', null)}
                            label={params.get('label', null)}
                            name={item.get('name')}
                            type={params.get('field_type')}
                            error={submitErrors && submitErrors.getIn(['additions', item.get('name')])}
                        />
                    </Form.Row>
                );

            default:
                return <div>Addition type "{item.get('type')}" is not supported yet.</div>
        }
    }

    render() {
        const {additions, handleSubmit, onSubmit, validationData} = this.props;
        const submitFailed = validationData.getIn(['additions', 'submitFailed']);
        const error = validationData.getIn(['additions', 'error']);
        return (
            <div className={styles.container}>
                {submitFailed ?
                    (<Alert type='warning'>
                        <FormattedMessage
                            id={"frontend.additions.error." + error}/>
                    </Alert>) : null}
                <br/>
                <div>
                    <Form onSubmit={handleSubmit(onSubmit)}>

                        {
                            additions.map((addition, key) => {
                                const hint = addition.get('hint');
                                return (
                                    <Form.Fieldset key={key}>
                                        <h3>
                                            {addition.get('title')}
                                        </h3>
                                        { hint ? <p>{hint}</p> : null}
                                        {
                                            addition.get('items').map((item, fkey) => {
                                                return <div key={fkey}>{this.renderItem(item, fkey)}</div>
                                            })
                                        }
                                    </Form.Fieldset>
                                )
                            })
                        }

                        <Button
                            type="submit"
                            block
                            disabled={this.props.submitting}
                            emphasis="primary"
                            className={styles.handleNext}
                        >
                            <FormattedMessage id='frontend.form_additions.button.continue'/>
                        </Button>

                    </Form>
                </div>
            </div>
        );
    }
}

let FormComponent = reduxForm({
    form: 'additions',
})(AdditionsForm);

FormComponent = connect(state => ({
    validationData: state.form,
    initialValues: state.order.get('additions').toJS(),
}))(FormComponent);

// See https://github.com/erikras/redux-form/issues/1010
export default {
    Component: FormComponent,
};
